import posthog from 'posthog-js'

export type AnalyticsEvent =
  // Auth
  | 'auth_login_success'
  | 'auth_login_failed'
  | 'auth_logout'
  // Leagues
  | 'league_joined'
  | 'league_left'
  | 'league_detail_viewed'
  // Matches
  | 'match_room_entered'
  | 'match_started'
  | 'match_result_submitted'
  | 'match_forfeited'
  | 'match_schedule_proposed'
  | 'match_result_confirmed'
  | 'match_result_disputed'
  | 'match_chat_sent'
  | 'match_screenshot_uploaded'
  // Teams
  | 'team_created'
  | 'team_join_requested'
  | 'team_invitation_sent'
  | 'team_invitation_responded'
  | 'team_request_handled'
  | 'team_member_removed'
  | 'team_branding_updated'
  // Game servers
  | 'gameserver_sftp_credentials_fetched'
  | 'gameserver_sftp_credentials_rotated'
  // Landing
  | 'landing_anticheat_learn_more_clicked'
  // Wallet
  | 'wallet_connected'
  | 'wallet_withdrawal_initiated'
  // Search & Nav
  | 'search_executed'
  | 'search_result_clicked'
  | 'nav_desktop_app_clicked'
  | 'nav_widget_match_clicked'
  // Social
  | 'user_followed'
  | 'user_unfollowed'
  | 'post_published'
  | 'post_liked'
  | 'post_reshared'
  // Communities
  | 'community_joined'
  | 'community_left'
  | 'community_created'
  // Streaming
  | 'stream_watched'
  | 'stream_follow_toggled'
  // Profile & Settings
  | 'profile_updated'
  | 'profile_tab_changed'
  | 'settings_preferences_saved'
  | 'settings_steam_connected'
  | 'settings_discord_connected'
  // Game Servers
  | 'gameserver_landing_viewed'
  | 'gameserver_pricing_clicked'
  | 'gameserver_cta_clicked'
  | 'gameserver_config_opened'
  | 'gameserver_configured'
  | 'gameserver_payment_initiated'
  | 'gameserver_payment_completed'
  | 'gameserver_payment_failed'
  | 'gameserver_dashboard_viewed'
  | 'gameserver_dashboard_tab_changed'
  | 'gameserver_action'
  | 'gameserver_connection_copied'
  | 'gameserver_billing_viewed'
  | 'gameserver_invoice_paid'
  | 'gameserver_settings_saved'
  | 'gameserver_autopay_enable_clicked'
  | 'gameserver_autopay_cancel_clicked'
  | 'gameserver_file_action'
  | 'gameserver_rcon_executed'
  | 'gameserver_logs_viewed'
  // Landing Pages
  | 'landing_page_viewed'
  | 'landing_cta_clicked'
  | 'landing_video_played'
  | 'landing_download_clicked'
  | 'landing_partnership_submitted'
  | 'landing_game_requested'
  | 'landing_signup_clicked'
  | 'landing_anticheat_download_clicked'
  // DePIN
  | 'depin_page_viewed'
  | 'depin_faq_expanded'
  | 'depin_download_clicked'
  | 'depin_cta_clicked'
  // Tournaments
  | 'tournament_browse_viewed'
  | 'tournament_view_changed'
  | 'tournament_game_filtered'
  | 'tournament_card_clicked'
  | 'community_bracket_card_clicked'
  | 'tournament_create_initiated'
  | 'tournament_detail_viewed'
  | 'tournament_tab_changed'
  | 'tournament_deleted'
  | 'tournament_joined'
  | 'tournament_left'
  | 'tournament_started'
  | 'tournament_ended'
  | 'tournament_bracket_viewed'
  | 'tournament_match_clicked'
  | 'tournament_result_submitted'
  // Browse & Detail Pages
  | 'games_page_viewed'
  | 'games_request_discord_clicked'
  | 'game_card_clicked'
  | 'game_detail_viewed'
  | 'game_tab_changed'
  | 'game_followed'
  | 'queue_cta_clicked'
  | 'league_hub_viewed'
  | 'league_hub_game_clicked'
  | 'teams_browse_viewed'
  | 'teams_tab_changed'
  | 'team_card_clicked'
  | 'team_detail_viewed'
  | 'team_detail_tab_changed'
  | 'team_strat_board_opened'
  | 'team_followed'
  | 'community_browse_viewed'
  | 'community_card_clicked'
  | 'forum_viewed'
  | 'shout_detail_viewed'
  | 'shout_comment_posted'
  // Remaining
  | 'store_viewed'
  | 'store_tab_changed'
  | 'notifications_viewed'
  | 'notification_clicked'
  | 'notifications_marked_read'
  | 'token_page_viewed'
  | 'comment_focus_viewed'
  | 'email_preferences_saved'
  | 'error_boundary_triggered'

export function track(event: AnalyticsEvent, properties?: Record<string, unknown>): void {
  try {
    posthog.capture(event, properties)
    console.debug('[Analytics]', event, properties)
  } catch {
    // Analytics should never crash the app
  }
}

export function identifyUser(userId: string, traits?: Record<string, unknown>): void {
  try {
    posthog.identify(userId, traits)
  } catch {
    // Silently fail
  }
}

export function resetUser(): void {
  try {
    posthog.reset()
  } catch {
    // Silently fail
  }
}
